import $ from 'jquery';
import scrollTo from './scrollTo.js';

$(function() {
  $("a[href='#RecommendedPackage']").on('click', function(e) {
    e.preventDefault();
    scrollTo($("#RecommendedPackage"));
  });

  $("a[href='#CallToAction']").on('click', function(e) {
    e.preventDefault();
    scrollTo($("#CallToAction"));
  });

  $("a[href='#TalkToExpert']").on('click', function(e) {
    e.preventDefault();
    scrollTo($("#TalkToExpert"));
  });
});